(function () {
  var shelves = document.querySelectorAll('.cp-home .cp-shelf');
  if (shelves.length < 4) return;

  var kidsShelf = shelves[2];
  var heading = kidsShelf.querySelector('h2');
  var productsContainer = kidsShelf.querySelector('.cp-products');
  if (!heading || !productsContainer) return;

  heading.textContent = 'საბავშვო წიგნები';
  kidsShelf.classList.add('cp-shelf--balanced-rail');
  productsContainer.setAttribute('aria-busy', 'true');

  var collectionHandles = ['0-5-წლამდე', '5-7-წლამდე', '7-14-წლამდე'];
  var requests = collectionHandles.map(function (handle) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Collection request failed');
      return response.json();
    });
  });

  Promise.all(requests).then(function (responses) {
    var seen = Object.create(null);
    var products = [];

    responses.forEach(function (response) {
      (response.products || []).forEach(function (product) {
        if (seen[product.id]) return;
        seen[product.id] = true;
        products.push(product);
      });
    });

    var formatter = new Intl.NumberFormat('ka-GE', {
      style: 'currency',
      currency: 'GEL'
    });

    productsContainer.innerHTML = '';
    products.forEach(function (product) {
      var image = product.images && product.images[0];
      var variant = product.variants && product.variants[0];
      var card = document.createElement('a');
      card.className = 'cp-card';
      card.setAttribute('data-available', variant && variant.available ? 'true' : 'false');
      if (product.title.indexOf('როგორ ველაპარაკოთ') !== -1) card.classList.add('cp-cover-shadow-pilot');
      card.href = '/products/' + product.handle;

      var stack = document.createElement('span');
      stack.className = 'cp-card__stack';

      var imageWrap = document.createElement('span');
      imageWrap.className = 'cp-card__image';
      if (image && image.src) {
        var imageElement = document.createElement('img');
        imageElement.src = image.src;
        imageElement.alt = image.alt || product.title;
        imageElement.loading = 'lazy';
        var syncCardWidth = function () {
          if (!imageElement.naturalWidth || !imageElement.naturalHeight) return;
          var ratio = imageElement.naturalWidth / imageElement.naturalHeight;
          var square = ratio > 0.9 && ratio < 1.1;
          if (square) card.classList.add('cp-card--square');
          card.style.setProperty('--cp-card-desktop-width', square ? '203px' : (ratio * 290).toFixed(2) + 'px');
          card.style.setProperty('--cp-card-mobile-width', square ? '42vw' : (ratio * 60.5).toFixed(2) + 'vw');
        };
        imageElement.addEventListener('load', syncCardWidth);
        imageWrap.appendChild(imageElement);
        if (imageElement.complete) syncCardWidth();
      }

      var title = document.createElement('strong');
      title.textContent = product.title;
      stack.appendChild(imageWrap);
      stack.appendChild(title);

      if (variant) {
        var prices = document.createElement('span');
        prices.className = 'cp-card__prices';
        var price = Number(variant.price);
        var compareAtPrice = Number(variant.compare_at_price || 0);
        if (compareAtPrice > price) {
          var oldPrice = document.createElement('s');
          oldPrice.textContent = formatter.format(compareAtPrice);
          var currentPrice = document.createElement('b');
          currentPrice.textContent = formatter.format(price);
          prices.appendChild(oldPrice);
          prices.appendChild(currentPrice);
        } else {
          prices.textContent = formatter.format(price);
        }
        stack.appendChild(prices);
      }

      card.appendChild(stack);
      productsContainer.appendChild(card);
    });
  }).catch(function () {
    kidsShelf.hidden = true;
  }).finally(function () {
    productsContainer.removeAttribute('aria-busy');
    document.dispatchEvent(new CustomEvent('cp:kids-shelf-ready'));
    });
})();
